import { Link } from '@inertiajs/react';
import { mdiHeart } from '@mdi/js';
import Icon from '@mdi/react';

export function SiteFooter() {
    return (
        <footer className='border-t border-gray-300'>
            <div className='mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-2 px-4 py-4 text-slate-900 desktop:flex-row desktop:px-8 desktop:py-8'>
                <span>
                    <span className='font-semibold'>© AdventureList</span>{' '}
                    <span className='inline-flex items-center text-slate-600'>
                        &ndash; Made with <Icon path={mdiHeart} className='mx-1 size-4 text-red-500' />
                        in Chicago
                    </span>
                </span>
                <div className='flex gap-4 font-semibold text-slate-900'>
                    <a href='mailto:contact@adventurelist.app' target='_blank' rel='noreferrer'>
                        Contact
                    </a>
                    <Link href={route('terms')}>Terms & Conditions</Link>
                    <Link href={route('privacy')}>Privacy</Link>
                </div>
            </div>
        </footer>
    );
}
